import api from './api';

export const dashboardService = {
    async getDashboard() {
        const response = await api.get('/vendors/dashboard');
        return response.data;
    },
};

export default dashboardService;
